import * as _ from "lodash-es";
import moment from "moment";
import React, { Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IForecastItemsDTO from "../../../models/DTO/IForecastItemsDTO";
import IGetCatalogItemsDTO from "../../../models/DTO/IGetCatalogItemsDTO";
import IGetForecastGroupDTO from "../../../models/DTO/IGetForecastGroupDTO";
import IOnGetCatalogItemsDTO from "../../../models/DTO/IOnGetCatalogItemsDTO";
import IOnGetForecastGroupDTO from "../../../models/DTO/IOnGetForecastGroupDTO";
import IOnUpdateForecastItemsDTO from "../../../models/DTO/IOnUpdateForecastItemsDTO";
import IUpdateForecastItemsDTO from "../../../models/DTO/IUpdateForecastItemsDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IForecast_Group from "../../../models/IForecast_Group";
import IForecast_Item from "../../../models/IForecast_Item";
import IOwTableCols from "../../../models/IOwTableCols";
import IOwTableConfig from "../../../models/IOwTableConfig";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import SortOrderEnum from "../../../models/SortOrderEnum";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import ForecastDetail from "../ForecastDetail/ForecastDetail";
import { Socket } from "socket.io-client";

type Props = {
    match: any;
    history: any;
    location: any;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    setActivityIndicator?: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    navItems: IBreadcrumbs[];
    forecastGroup?: IForecast_Group;
    forecastGroupGuid: string;
    fetchingData: boolean;
    initialData: boolean;
    detailCols: IOwTableCols[];
    isFirstHalf: boolean;
    dataSet: IForecast_Item[];
    catalogItems: ICatalog_Item[];
    hasChanges: boolean;
    saveActive: boolean;
    tableConfig: IOwTableConfig;
};

class ForecastDetailView extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const navItems = [
            { title: "Dashboard", url: "/dashboard" },
            { title: "Forecast", url: "/forecast" },
            { title: "Detail View", url: "/forecast/:guid" },
        ];

        this.state = {
            navItems,
            forecastGroupGuid: this.props.match.params.guid,
            fetchingData: false,
            initialData: true,
            detailCols: [],
            isFirstHalf: false,
            dataSet: [],
            catalogItems: [],
            hasChanges: false,
            saveActive: false,
            tableConfig: {
                tableHover: true,
                alignHeadersMiddle: true,
            },
        };
    }

    componentDidMount(): void {
        this.props.socket.on("onGetForecastGroup", this.onGetForecastGroup);
        this.props.socket.on("onGetCatalogItems", this.onGetCatalogItems);
        this.props.socket.on("onUpdateForecastItems", this.onUpdateForecastItems);

        this.getForecastGroup();
    }

    componentWillUnmount(): void {
        this.props.socket.on("onGetForecastGroup", this.onGetForecastGroup);
        this.props.socket.on("onGetCatalogItems", this.onGetCatalogItems);
        this.props.socket.on("onUpdateForecastItems", this.onUpdateForecastItems);
    }

    getCatalogItems = () => {
        if (this.state.forecastGroup && this.state.forecastGroup.Vendor && this.state.forecastGroup.Catalog) {
            const payload: IGetCatalogItemsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.forecastGroup.Vendor.guid,
                catalogGuid: this.state.forecastGroup.Catalog.guid,
                limit: 250,
            };

            this.props.socket.emit("getCatalogItems", payload);
        }
    };

    processAndSetupForecastRows = () => {
        const forecastItems = this.state.forecastGroup!.Forecast_Items || [];

        const forecastItemsNotFound: IForecast_Item[] = [];

        for (const catalogItem of this.state.catalogItems) {
            let foundForecastItem: IForecast_Item | undefined = undefined;
            let index = 0;
            let foundIndex = 0;

            for (const forecastItem of forecastItems) {
                if (forecastItem.catalog_item_id === catalogItem.id) {
                    foundForecastItem = forecastItem;
                    foundIndex = index;
                }

                index = index + 1;
            }

            if (!foundForecastItem) {
                const newForecastItem: any = {
                    forecast_group_id: this.state.forecastGroup!.id,
                    catalog_id: this.state.forecastGroup!.catalog_id,
                    catalog_item_id: catalogItem.id,
                    Catalog_Item: catalogItem,
                    forecast_detail: [],
                    month_one: "",
                    month_two: "",
                    month_three: "",
                    month_four: "",
                    month_five: "",
                    month_six: "",
                };

                let months: number[] = [1, 2, 3, 4, 5, 6];

                if (!this.state.isFirstHalf) {
                    months = [7, 8, 9, 10, 11, 12];
                }

                // let forecast_detail = months.map((month_num, index: number) => {
                //     return {
                //         month_num,
                //         value: '',
                //     }
                // });
                //
                // newForecastItem.forecast_detail = forecast_detail;

                forecastItemsNotFound.push(newForecastItem);
            }
        }

        const dataSet = [...forecastItems, ...forecastItemsNotFound];

        console.log("dataSet", dataSet);

        this.setState(
            {
                dataSet,
            },
            () => {
                this.sortRows("catalog_item", SortOrderEnum.ASC);
            }
        );
    };

    onGetCatalogItems = (data: IOnGetCatalogItemsDTO) => {
        console.log("onGetCatalogItems", data);

        this.setState(
            {
                fetchingData: false,
                catalogItems: data.catalog_items,
            },
            () => {
                this.processAndSetupForecastRows();
            }
        );
    };

    handleMonthForecastChange = (row: IForecast_Item, e: any) => {
        console.log("handleMonthForecastChange", row, e.target.name, e.target.value);
        const dataSet = this.state.dataSet;

        for (let i = 0; i < dataSet.length; ++i) {
            const dataItem = dataSet[i];
            const changed = false;

            if (dataItem.catalog_item_id === row.catalog_item_id) {
                const monthNum = Number(moment().month(e.target.name).format("M"));

                console.log("monthNum", monthNum);
                switch (monthNum) {
                    case 1:
                    case 7:
                        dataItem.month_one = e.target.value;
                        break;

                    case 2:
                    case 8:
                        dataItem.month_two = e.target.value;
                        break;

                    case 3:
                    case 9:
                        dataItem.month_three = e.target.value;
                        break;

                    case 4:
                    case 10:
                        dataItem.month_four = e.target.value;
                        break;

                    case 5:
                    case 11:
                        dataItem.month_five = e.target.value;
                        break;

                    case 6:
                    case 12:
                        dataItem.month_six = e.target.value;
                        break;
                }

                // for (let j = 0; j < dataItem.forecast_detail.length; ++j) {
                //     let detailItem = dataItem.forecast_detail[j];
                //
                //     if (Number(detailItem.month_num) === monthNum) {
                //         detailItem.value = e.target.value;
                //         console.log('setting detailItem.value', detailItem);
                //         changed = true;
                //     }
                // }
            }

            // if (changed) {
            //     this.state.dataSet[i] = dataItem;
            // }
        }

        this.setState({
            dataSet,
            hasChanges: true,
        });
    };

    getForecastGroup = () => {
        const payload: IGetForecastGroupDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            forecastGroupGuid: this.state.forecastGroupGuid,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit("getForecastGroup", payload);

        this.setState({
            fetchingData: true,
        });
    };

    onGetForecastGroup = (data: IOnGetForecastGroupDTO) => {
        const periodStart = moment(data.period_start).quarter() <= 2 ? "H1" : "H2";

        const detailCols: IOwTableCols[] = [
            {
                title: "catalog_item",
                valueProp: "Catalog_Item",
                valueSubProp: "name",
                className: "w-20r",
                isSortable: true,
                sortFn: this.sortRows,
                sortOrder: SortOrderEnum.ASC,
            },
            {
                title: "sku",
                valueProp: "Catalog_Item",
                valueSubProp: "sku",
                className: "text-nowrap",
            },
        ];

        let months = ["january", "february", "march", "april", "may", "june"];

        if (periodStart !== "H1") {
            months = ["july", "august", "september", "october", "november", "december"];
        }

        const index = 0;

        for (const month of months) {
            let month_prop = "";

            switch (month) {
                case "january":
                case "july":
                    month_prop = "one";
                    break;

                case "february":
                case "august":
                    month_prop = "two";
                    break;

                case "march":
                case "september":
                    month_prop = "three";
                    break;

                case "april":
                case "october":
                    month_prop = "four";
                    break;

                case "may":
                case "november":
                    month_prop = "five";
                    break;

                case "june":
                case "december":
                    month_prop = "six";
                    break;
            }

            detailCols.push({
                title: month,
                // isArray: true,
                // arrayIndex: index,
                valueProp: `month_${month_prop}`,
                isTextInput: true,
                inputFn: this.handleMonthForecastChange,
            });
        }

        detailCols.push({
            title: "total",
            valueProp: "",
            renderFn: this.calculateRowTotal,
            renderFnEmitsRow: true,
        });

        this.setState(
            {
                forecastGroup: data,
                initialData: false,
                isFirstHalf: periodStart === "H1",
                detailCols,
            },
            () => {
                this.getCatalogItems();
            }
        );
    };

    calculateRowTotal = (row: IForecast_Item): string => {
        const { month_one, month_two, month_three, month_four, month_five, month_six } = row;

        const total =
            Number(month_one) + Number(month_two) + Number(month_three) + Number(month_four) + Number(month_five) + Number(month_six);

        return total.toString();
    };

    sortRows = (sortCol: string, sortOrder: SortOrderEnum) => {
        console.log("sortRows", sortCol, sortOrder);
        const dataSet = this.state.dataSet;

        let sortedDataSet = _.sortBy(dataSet, (dataItem: IForecast_Item) => {
            return dataItem.Catalog_Item ? dataItem.Catalog_Item.name : "";
        });

        if (sortOrder === SortOrderEnum.DESC) {
            sortedDataSet = sortedDataSet.reverse();
        }
        console.log("sortedDataSet", sortedDataSet);

        const detailCols = this.state.detailCols;

        for (const detailCol of detailCols) {
            if (detailCol.title === sortCol) {
                detailCol.sortOrder = sortOrder;
            }
        }

        this.setState({
            dataSet: sortedDataSet,
            detailCols,
        });
    };

    saveForecastItems = () => {
        const forecastItems: IForecastItemsDTO[] = [];

        for (const forecastItem of this.state.dataSet) {
            const dataItem: IForecastItemsDTO = {
                catalogItemGuid: forecastItem.Catalog_Item!.guid,
                month_one: forecastItem.month_one,
                month_two: forecastItem.month_two,
                month_three: forecastItem.month_three,
                month_four: forecastItem.month_four,
                month_five: forecastItem.month_five,
                month_six: forecastItem.month_six,
            };

            if (forecastItem.guid) {
                dataItem.guid = forecastItem.guid;
            }

            forecastItems.push(dataItem);
        }

        const payload: IUpdateForecastItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            forecastItems,
            forecastGroupGuid: this.state.forecastGroupGuid,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit("updateForecastItems", payload);

        this.setState({
            saveActive: true,
        });
    };

    onUpdateForecastItems = (data: IOnUpdateForecastItemsDTO) => {
        this.setState(
            {
                saveActive: false,
                hasChanges: false,
            },
            () => {
                this.getForecastGroup();
            }
        );
    };

    render() {
        return (
            <div className="ForecastDetailView">
                <Breadcrumbs navItems={this.state.navItems} />

                <div className={"mt-2 d-flex flex-column"}>
                    <div className={"d-flex"}>
                        <div className={"d-inline-flex"}>
                            <OwTitle title={"forecast"} leftIconName={"fad fa-chart-line"} />
                        </div>
                        <div className={"d-flex align-items-end ms-auto flex-column"}>
                            <div>
                                <OwButton
                                    fn={this.saveForecastItems}
                                    title={"save"}
                                    className={"btn btn-success btn-sm"}
                                    active={this.state.saveActive}
                                    disabled={this.state.saveActive}
                                />
                            </div>

                            <div>
                                {this.state.hasChanges ? <OwLabel title={"pending_changes_not_saved"} className={"text-danger"} /> : null}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"mt-2"}>
                    <ForecastDetail
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        vendorModel={this.props.vendorModel}
                        forecastGroup={this.state.forecastGroup}
                    />
                </div>

                <div className={"mt-2"}>
                    <OwTable
                        columns={this.state.detailCols}
                        dataSet={this.state.dataSet}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.fetchingData}
                        initialData={this.state.initialData}
                        tableConfig={this.state.tableConfig}
                    />
                </div>
            </div>
        );
    }
}

export default ForecastDetailView;
